module.exports = __webpack_public_path__ + "assets/ziare.66b6b721.svg";